import React from 'react';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider
} from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { Link as RouterLink } from 'react-router-dom';
import avatar from 'src/assets/images/Unaut.png';
import Page from 'src/components/Page';

function Unauthorized() {
  return (
    <Page title="Yetkisiz Kullanıcı">
      <Card>
        <CardHeader title={'Giriş Yetkiniz Bulunmuyor!...'}
          subheader={'Artemis giriş sayfasına aşağıdaki buton ile ulaşabilirsiniz'}></CardHeader>
        <Divider />
        <CardContent align="center">
          <img alt="Person" src={avatar} style={{ width: 300, height: 300 }} />
        </CardContent>
        <Divider />
        <CardActions>
          <Button
            color="secondary"
            component={RouterLink}
            fullWidth
            to="/"
            variant="contained"
            endIcon={<ArrowBackIcon>Back</ArrowBackIcon>}
          >
            Artemİs Gİrİş
          </Button>
        </CardActions>
      </Card>
    </Page>
  );
}

export default Unauthorized;
